(function (){
    'use strict';

    $(() => {
        $(".lottie-animation").each(function () {
            const container = $(this)[0];
            const animation = lottie.loadAnimation({
                container: container,
                path: '/animations/' + $(this).data('animation') + '/data.json',
                renderer: 'svg',
                loop: false,
                controls: true,
                autoplay: false,
                name: $(this).data('animation-name'),
                rendererSettings: {
                    imagePreserveAspectRatio: "xMinYMin slice"
                }
            });

            function playAnimation() {
                if (!container.classList.contains('playing') && !container.classList.contains('paused')) {
                    animation.goToAndPlay(0);
                    container.classList.add('playing');
                }
            }

            container.addEventListener('click', () => {
                if(container.classList.contains('animation-pausable')) {
                    if(container.classList.contains('paused')) {
                        container.classList.remove('paused');
                        animation.play();
                    } else {
                        container.classList.add('paused');
                        animation.pause();
                    }
                } else {
                    playAnimation();
                }
            }, false);
            container.addEventListener('mouseenter', playAnimation, false);

            animation.addEventListener('DOMLoaded', () => {
                ScrollTrigger.create({
                    markers: false,
                    trigger: container,
                    start: `top 70%`,
                    end: `bottom 30%`,
                    onEnter: () => {
                        // console.log('onEnter');
                        playAnimation();
                    },
                    onEnterBack: () => {
                        // console.log('onEnterBack');
                        playAnimation();
                    },
                })
            }, false);

            animation.addEventListener('complete', () => {
                container.classList.remove('playing')
            });
        });
    })
}(jQuery));
